import { Action } from "csi/def/Action";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import BooleanRen from "csi/heading/Boolean";
import { defaultToReactForm } from "csi/service/viewService";
import declare from "dojo/_base/declare";

const IsNewFormBuilderRenderer = declare(BooleanRen, {

	/**
	 * @override
	 * Disable opt-in checkbox if a node type is defaulting to React form
	 */
	_getRenderAction(ctx: Context, h: Heading): Action | null {
		if (defaultToReactForm(ctx.getNodeParent().$Name)) {
			return null;
		}

		return this.inherited<Action>(arguments);
	},
});

export = IsNewFormBuilderRenderer;
